export default {
  home: "Tutellus — Inicio",
  tagline: "Mejoramos el mundo con negocios tokenizados.",
  sections: {
    emprende: "Emprende",
    invierte: "Invierte",
    ecosistema: "Ecosistema",
  },
  links: {
    tok120: "Programa TOK120",
    taller: "Taller de Tokenización",
    packRwa: "Pack RWA",
    builders: "Tutellus Builders",
    certificaciones: "Certificaciones Tutellus",
    consultoria: "Consultoría en Tokenización",
    inversionSegura: "Inversión Segura",
    defiAvanzado: "DeFi Avanzado",
    club: "Club de Inversión",
    stakiny: "Stakiny",
    gt3: "GT3",
    dappComposer: "DAPPComposer",
    humanWallet: "HumanWallet",
    comunidad: "Comunidad Tutelliana",
    criptoblog: "Criptoblog",
    mafia: "Tutellus Mafia",
  },
  legal: {
    privacy: "Política de privacidad",
    cookies: "Política de Cookies",
    legalNotice: "Aviso legal",
  },
  copy: "© {{year}} Tutellus.",
}
